export default {
    slug: 'payments',
    prefix: 'billing',
    title: 'Payments',
    visible: [
        'amount',
        'type',
        'status',
        'time',
        'comment'
    ],
    listview: 'PaymentsListView',
    locales: ['common'],
    actions: {
        // details: {
        //     title: 'Details',
        //     level: 'row',
        //     vm: 'showDetails'
        // },
    },
    copyColumns: [
        'comment',
        'failure_reason'
    ],
    tooltipColumns: [
        'comment',
        'failure_reason'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/billing/payments/state.js